import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import CustomDisclaimerModalUI from "./CustomDisclaimerModal.ui.tsx";
import { ExternalProps } from "./CustomDisclaimerModal.types.tsx";

import { getDisclaimer } from "../../services/legal.services.tsx";

export const useCustomDisclaimerModal = ({ onAccept }: ExternalProps) => {
  const { i18n } = useTranslation();

  const [show, setShow] = useState(false);
  const [disclaimerText, setDisclaimerText] = useState("");

  const open = () => setShow(true);
  const close = () => setShow(false);

  useEffect(() => {
    const loadDisclaimer = async () => {
      try {
        const language = i18n.language.split("-")[0];

        const disclaimer = await getDisclaimer(language);

        setDisclaimerText(disclaimer);
      } catch (e: unknown) {
        const message = e instanceof Error ? e.message : "API Error";
        toast.error(`Error: ${message}`);
      }
    };

    loadDisclaimer();
  }, [i18n.language]);

  const handleAccept = () => {
    close();
    onAccept();
  };

  const modal = (
    <CustomDisclaimerModalUI
      show={show}
      handleClose={close}
      handleAccept={handleAccept}
      disclaimerText={disclaimerText}
    />
  );

  return { open, close, modal };
};
